<template>
  <v-select
    :name="name"
    :value="optionSelected"
    :options="optionsList"
    :class="{ 'v-select-danger': danger, 'select-size-sm': small }"
    :disabled="isDisabled"
    :clearable="clearable"
    :placeholder="computedPlaceholder"
    :selectable="opt => !opt.disabled"
    @input="onInput"
  >
    <template #spinner>
      <b-spinner
        small
        v-if="isapresState.loading"
        :style="{ opacity: isapresState.loading ? 1 : 0 }"
        variant="primary"
      />
    </template>
    <template slot="no-options">
      No hay opciones para el criterio de búsqueda
    </template>
  </v-select>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'VSelectIsapres',
  computed: {
    ...mapGetters('List', [
      'isapresState'
    ]),
    computedPlaceholder() {
      return this.isapresState.loading ? 'Cargando opciones...' : this.placeholder;
    },
    optionSelected() {
      return this.optionsList.find((option) => option.value === this.value);
    },
    optionsList() {
      return [
        ...(this.includeFonasa ? [{
          value: 'FONASA',
          label: 'FONASA',
          disabled: false
        }] : []),
        ...this.isapresState.list
      ];
    },
    isDisabled() {
      return this.disabled
        || !this.optionsList.length
        || this.isapresState.loading;
    },
  },
  methods: {
    ...mapActions('List', [
      'fetchIsapres'
    ]),
    onInput(event) {
      this.$emit('full-group', event);
      this.$emit('input', event?.value);
    },
  },
  created() {
    if (this.parent[`_fetch-${this.$vnode.tag}`]) return;
    this.fetchIsapres().then(() => {
      if (this.parent) this.parent[`_fetch-${this.$vnode.tag}`] = true;
    });
  },
  props: {
    parent: { type: Object, required: true },

    name: { type: String, required: true },
    danger: { type: Boolean },
    disabled: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    placeholder: { type: String, default: 'Por favor, seleccione una opción' },
    value: { type: String },

    includeFonasa: { type: Boolean, default: false },
  }
};
</script>
